import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./BabySizeImageCard.module.scss"; // Import SCSS styles
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { useTranslation } from "react-i18next";
import { ImageWeekInfo } from "../../utility/interfaces/babyWeekImageDataInterface";
import noImage from "../../assets/icons/no_image.svg";
interface BabySizeImageCardProps {
  onViewAll: () => void;
  data: ImageWeekInfo;
}

const BabySizeImageCard: React.FC<BabySizeImageCardProps> = ({
  onViewAll,
  data,
}) => {
  const { t } = useTranslation();
  const imageText = data.imageText.toLowerCase();

  return (
    <Box className={styles.babySizeImageWidgetContainer}>
      <Typography variant="h3">
        {t("babyWeekImages.weekPregnancyText", {
          week: data.pregnancyWeekDisplayName,
        })}
      </Typography>

      <Typography
        variant="body1"
        pt={2}
      >
        {t("babyWeekImages.babySizeDescription", {
          size: imageText,
        })}
      </Typography>
      <Typography
        variant="body1"
        pt={2}
      >
        {`${data.size} ${t("babyWeekImages.inch")}  | ${data.weight}`}
      </Typography>

      <Box className={styles.babySizeImages}>
        <Box className={styles.ellipseWrapper}>
          <Box className={styles.ellipseInner}>
            <img
              src={data.imagePath}
              alt={data.imageText}
              className={styles.babyImage}
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = noImage;
                target.style.width = "46px";
                target.style.height = "46px";
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box className={styles.buttonContainer}>
        <CustomButton
          variant="outlined"
          text={t("carePlan.viewAllWeeks")}
          onClick={onViewAll}
        />
      </Box>
    </Box>
  );
};

export default BabySizeImageCard;
